import { PaperClipOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import config from 'config';
import { format, addDays } from 'date-fns';
import { LabworkOutput, LabworkStatus } from 'gql/types';
import LabworkCardInfo from 'modules/donor/components/LabworkCardInfo';
import { useLabworkAttachmentsModalContext } from 'modules/donor/contexts/LabworkAttachmentsModal';
import { useCurrentUser } from 'modules/user/hooks/useCurrentUser';
import { FC } from 'react';

import styles from './styles.module.scss';

type PropTypes = {
  labwork: LabworkOutput;
  updateLabworkHandler: (data: LabworkOutput) => void;
  updateLabworkStatusHandler: (id: string, status: LabworkStatus) => void;
  className: string;
};

const LabworkCard: FC<PropTypes> = ({ className, ...restProps }) => {
  const labworkAttachmentsModal = useLabworkAttachmentsModalContext();
  const canUpdateLabwork =
    useCurrentUser().data?.permissions?.updateLabworkData || false;
  const canShareLabworkResults =
    useCurrentUser().data?.permissions?.shareLabworkResults || false;
  const canDeleteLabwork =
    useCurrentUser().data?.permissions?.deleteLabworkData || false;

  const attributes = {
    ...restProps,
    canUpdateLabwork,
    canShareLabworkResults,
    canDeleteLabwork,
  };

  const openLabworkAttachmentsModal = () => {
    labworkAttachmentsModal?.showModal({ labworkId: restProps.labwork.id });
  };

  return (
    <Card
      className={`${styles.labworkCard} ${className}`}
      title={format(
        addDays(
          new Date(restProps.labwork.collectionDate),
          config.VALIDITY_PERIODS.LABWORK_DURATION_DAYS
        ),
        config.DATE_FORMATS.DATE
      )}
      extra={
        <PaperClipOutlined
          className={styles.clipIcon}
          onClick={openLabworkAttachmentsModal}
        />
      }
    >
      <LabworkCardInfo {...attributes} />
    </Card>
  );
};

export default LabworkCard;
